<div *ngFor="let doc of documents">
    <div class="w-11/12 py-4 px-8 bg-white shadow-2xl rounded-lg mx-12 my-8">
        <div class="flex flex-column">
            <h5 class="text-gray-800 w-1/2 text-xl font-semibold">{{doc.title}}</h5>
            <button
                class="justify-self-end self-end w-1/6 my-4 bg-red-400 hover:bg-red-300 rounded text-white p-2 pl-4 pr-4"
                (click)="goToView(doc.id)">
                See more
            </button>
        </div>
    </div>
</div>